import AccountRoute from '~/pages/account/account.route';
import AdminClassDesignerRoute from '~/pages/admin/class-designer/admin-class-designer.route';
import AdminKiaDoctypeRoute from '~/pages/admin/kia-doctype/admin-kia-doctype.route';
import AdminKonvRoute from '~/pages/admin/konv/admin-konv.route';
import AdminOORoute from '~/pages/admin/oo/admin-oo.route';
import AdminWFRoute from '~/pages/admin/wf/admin-wf.route';
import Batch from '~/pages/batch/batch.route';
import Chat from '~/pages/chat/chat.route';
import ClassDesignerBeta from '~/pages/admin/class-designer-beta/class-designer.route';
import Dev4 from '~/pages/dev4/dev4.route';
import Dev5 from '~/pages/dev5/dev5.route';
import Dev6 from '~/pages/dev6/dev6.route';
import Dev7 from '~/pages/dev7/dev7.route';
import DevRoute from '~/pages/dev/dev.route';
import {
	routeNew as FormBuilderRouteNew,
	routeView as FormBuilderRouteView,
} from '~/pages/form-builder/form-builder.route';
import FormRoute from '~/pages/form/form.route';
import FormRouteV5 from '~/pages/formV5/form.route';
import Help from '~/pages/help/help.route';
import HomeRoute from '~/pages/home/home.route';
import ImportFileDashboardV5 from '~/pages/import-file/import-file-dashboard.route';
import ImportFileExecutionsV5 from '~/pages/import-file/import-file-executions.route';
import ListRoute from '~/pages/list/list.route';
import LoginRoute from '~/pages/login/login.route';
import MigrationRoute from '~/pages/migration/migration.route';
import PassChange from '~/pages/passchange/passchange.route';
import PredictDoctypeRoute from '~/pages/predict-doctype/predict-doctype.route';
import PreviewRoute from '~/pages/preview/preview.route';
import QueryRoute from '~/pages/query/query.route';
import TemplateExport from '~/pages/template-export/template-export.route';
import TemplateExportNew from '~/pages/template-export/new/template-export-new.route';
import UploadRoute from '~/pages/upload/upload.route';
import Users from '~/pages/users/users.route';
import WikiRoute from '~/pages/wiki/wiki.route';
import WorkflowRoute from '~/pages/workflow/workflow.route';

// Controllers
import Dashboard from '~/pages/dashboard/dashboard.route';
import e2eRoute from '~/pages/e2e/e2e.route';
import AgendaV5 from '~/pages/agenda/agenda.route';
import QuickImportV5 from '~/pages/quickimport/quickimport.route';
import AdminUpload from '~/pages/admin/upload/admin-upload.route';
import NotificationListV5 from '~/pages/notification-list/notification-list.route';
import NotificationEditV5 from '~/pages/notification-edit/notification-edit.route';
import ESignV5 from '~/pages/e-sign/e-sign.route';
import NotificationNewV5 from '~/pages/notification-new/notification-new.route';
import FileTransferV5 from '~/pages/file-transfer/file-transfer.route';
import AktivNoteV5 from '~/pages/aktivnote/aktivnote.route';
import AktivnoteMatrixV5 from '~/pages/aktivnote-matrix/aktivnote-matrix.route';
import ReplayV5 from '~/pages/replay/replay.route';

/**
 * @type {Array<Router.Route>}
 */
const routes = [
	// @ts-ignore
	AccountRoute,
	AdminClassDesignerRoute,
	AdminKiaDoctypeRoute,
	AdminKonvRoute,
	AdminOORoute,
	AdminUpload,
	AdminWFRoute,
	AgendaV5,
	AktivNoteV5,
	AktivnoteMatrixV5,
	Batch,
	Chat,
	Dashboard,
	ESignV5,
	FileTransferV5,
	FormRoute,
	FormRouteV5,
	FormBuilderRouteNew,
	FormBuilderRouteView,
	Help,
	HomeRoute,
	ImportFileDashboardV5,
	ImportFileExecutionsV5,
	ListRoute,
	LoginRoute,
	MigrationRoute,
	NotificationEditV5,
	NotificationListV5,
	NotificationNewV5,
	PassChange,
	PredictDoctypeRoute,
	PreviewRoute,
	QueryRoute,
	QuickImportV5,
	ReplayV5,
	TemplateExport,
	TemplateExportNew,
	UploadRoute,
	WorkflowRoute,
	{
		path: '/wiki/new',
		...WikiRoute,
	},
	{
		path: '/wiki/:kid/:action',
		...WikiRoute,
	},
	...Users,
];

// Dev & Test only routes
// eslint-disable-next-line no-undef
if (process.env.IS_TEST || process.env.NODE_ENV !== 'production') {
	routes.push(
		// Dev
		...DevRoute,
		Dev4,
		Dev5,
		Dev6,
		Dev7,
		{
			path:        '/dev',
			templateUrl: 'views/dev.html',
			controller:  'DevCtrl',
			title:       'dev',
		},
		{
			path:        '/dev/mf-form',
			templateUrl: 'views/dev/mf-form.html',
			controller:  'DevMFFormCtrl',
			title:       'dev MF Form',
		},
		{
			path:        '/tests/mf',
			templateUrl: 'views/tests/mf.html',
			controller:  'MFTestsCtrl',
			title:       'MF - Tests',
		},

		ClassDesignerBeta,

		// E2E
		...e2eRoute,
	);
}

export default routes;
